export const PROMO_CATEGORIES_ID = 'PROMO_CATEGORIES';
export const SUPER_SAVINGS_CATEGORIES_ID = 'SUPER_SAVINGS';
export const PROMO_ID = 'PROMO';
export const TOP_MENU_PROMOTION_LINK_ID = 'TOP_MENU_PROMOTION_LINK';
